import React, { Fragment } from 'react'
import { useState, useMedia, useCallback } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Carousel from 'components/ui/Carousel/Carousel'

import Products from './Products/Products'
import Tabs from './Tabs/Tabs'

import s from './ProductsCarousel.scss'


const options = {
  slidesToShow: 1,
  slidesToScroll: 1,
  touchMove: true,
  arrows: false,
  swipe: true,
}


const ProductsCarousel = ({ items, selectedItems, handleItemAdd, handleItemRemove }) => {
  const { isMobile } = useMedia()

  const [ selectedIndex, setSelectedIndex ] = useState(0)

  let slider

  const handleTabClick = useCallback((newIndex) => {
    setSelectedIndex(newIndex)

    if (slider) {
      slider.slickGoTo(newIndex)
    }
  }, [])

  const selectedGroup = Object.keys(items)[selectedIndex]

  return (
    <Fragment>
      <Tabs
        selectedIndex={selectedIndex}
        handleTabClick={handleTabClick}
      />
      <Box pt="24">
        {
          isMobile ? (
            <Carousel
              className={s.carousel}
              ref={(ref) => slider = ref}
              options={{ ...options, afterChange: setSelectedIndex }}
            >
              {
                Object.keys(items).map((productType) => (
                  <Products
                    key={productType}
                    columns={2}
                    products={items[productType]}
                    selectedItems={selectedItems}
                    onAdd={handleItemAdd}
                    onRemove={handleItemRemove}
                  />
                ))
              }
            </Carousel>
          ) : (
            <Products
              columns={4}
              products={items[selectedGroup]}
              selectedItems={selectedItems}
              onAdd={handleItemAdd}
              onRemove={handleItemRemove}
            />
          )
        }
      </Box>
    </Fragment>
  )
}


export default ProductsCarousel
